import React from "react";
import { connect } from 'react-redux';
import { securityHelper } from "../../../../../helpers/securityHelper";
import  'video.js';
import VideoThumbnail from 'react-video-thumbnail';
import "./VideoElement.css";
import NoThumb from "../../../../../assets/img/no_thumb.png"
class VideoElement extends React.Component {
    state={}
    generateYoutubeSource = () => {
        const { url } = this.props;
        let vUrl = url;
        if (!url.includes("https://www.youtube.com/watch?v=")) vUrl = 'https://www.youtube.com/watch?v=ruRI3RH5HcA';
        let id = vUrl.substring(vUrl.indexOf("v=") + 2, vUrl.length);
        return id;
    };
   
    render() {

        const { autoplay, loop, frame, style, editMode, selected, element, url, thumbnail } = this.props;
        let longVideo = !url.includes("https://www.youtube.com");
    
        return (
            <React.Fragment>
                {longVideo ? (
                    <div style={{ ...style, position: 'relative' }}>
                       {
                           !thumbnail && url ?  <VideoThumbnail
                           videoUrl={url}
                           thumbnailHandler={(thumbnail) => {
                             if(this.state.customThumb !== thumbnail) this.setState({
                                   customThumb: thumbnail
                               })
                           }}
                           width={0}
                           height={0}
                           style={{display:"none"}}
                           />:null
                       }
                        <video
                        
                            id={"my-video-" + securityHelper.createGuid()}
                            class="video-js"
                            controls
                            preload="auto"
                            style={{ width: '100%', height: '100%' }}
                            poster={thumbnail || this.state.customThumb || NoThumb}
                            controlsList="nodownload"
                            data-setup="{}"
                            
                        >
                            <source src={url} type="video/mp4" />
                            <source src={url} type="video/webm" />
                            <p class="vjs-no-js">
                                To view this video please enable JavaScript, and consider upgrading to a
                                web browser that
                      <a href="https://videojs.com/html5-video-support/" target="_blank"
                                >supports HTML5 video</a
                                >
                            </p>
                        </video>
                    </div>
                ) : <div style={{ ...style, position: 'relative' }}>
                        <iframe
                            data-youtube={`https://www.youtube.com/watch?v=${this.generateYoutubeSource()}`}
                            frameBorder={frame}
                            allowFullScreen="1"
                            style={{ width: '100%', height: '100%' }}
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                            title="YouTube video player"
                            src={`https://www.youtube.com/embed/${this.generateYoutubeSource()}?controls=1&amp;autoplay=${autoplay ? "1" : "0"}&amp;mute=1&amp;origin=https%3A%2F%2Fwww.jqueryscript.net&amp;loop=${loop ? "1" : "0"}&amp;rel=0&amp;ecver=2&amp;showinfo=${frame ? "1" : "0"}&amp;modestbranding=1&amp;enablejsapi=1&amp;widgetid=1`}
                        ></iframe>
                    </div>
                }
            </React.Fragment>
        )
    }

}
function mapStateToProps(state) {
  
    return {
        form: state.form,
        page: state.page,
        template: state.template.template,
        cms: state.cms,
    };
}
export default connect(mapStateToProps)(VideoElement);